import MuiDrawer from '@mui/material/Drawer';
import { useUserThemeContext } from '@src/main/ui/providers/user/UserThemeContextProvider';
import { FC, PropsWithChildren } from 'react';

interface DrawerProps {
  width: number;
}

const Drawer: FC<PropsWithChildren<DrawerProps>> = ({ children, width }) => {
  const { theme } = useUserThemeContext();
  return (
    <MuiDrawer
      sx={{
        flexShrink: 0,
        width,
        maxHeight: '95%',
        '& .MuiDrawer-paper': {
          width,
          border: 0,
          boxSizing: 'border-box',
          ...(theme === 'Corporate' && {
            color: 'white',
            backgroundColor: 'iberiaRed.main',
          }),
        },
      }}
      variant="permanent"
      anchor="left"
    >
      {children}
    </MuiDrawer>
  );
};

export default Drawer;
